import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'certificates',
  initialState: {
    certificates: null,
    selectedCertImageData: null,
  },
  reducers: {
    saveCertificates: (state, action) => {
      state.certificates = [...action.payload];
    },
    deleteCertificates: (state, action) => {
      state.certificates = null;
    },
    saveSelectedCertImage: (state, action) => {
      state.selectedCertImageData = action.payload;
    },
  },
});

export default slice.reducer;

// Actions
const { saveCertificates, deleteCertificates, saveSelectedCertImage } = slice.actions;

export const saveCertificateData = (currentCertificates) => async dispatch => {
  try {
    dispatch(saveCertificates(currentCertificates));
  } catch (e) {
    return console.error(e.message);
  }
}

export const deleteCertificateData = () => async dispatch => {
  try {
    return dispatch(deleteCertificates())
  } catch (e) {
    return console.error(e.message);
  }
}

export const saveSelectedCertImageData = (imageData) => async dispatch => {
  try {
    dispatch(saveSelectedCertImage(imageData));
  } catch (e) {
    return console.error(e.message);
  }
}
